// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_UploadReceiptResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /payroll/upload_receipt
 * Uploads a payment receipt document for a payroll execution
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_UploadReceiptResponseDados {
id: number
payment_rule_execution_id: number
blob_name: string
file_name: string
file_size: number
mime_type: string
uploaded_by: string
uploaded_at: string
}

export type Payroll_UploadReceiptResponse = ApiResponse<Payroll_UploadReceiptResponseDados>;

registerResponseContract('Payroll_UploadReceiptResponse', {
  id:                        { type: 'number',  required: true },
  payment_rule_execution_id: { type: 'number',  required: true },
  blob_name:                 { type: 'string',  required: true },
  file_name:                 { type: 'string',  required: true },
  file_size:                 { type: 'number',  required: true },
  mime_type:                 { type: 'string',  required: true },
  uploaded_by:               { type: 'string',  required: true },
  uploaded_at:               { type: 'string',  required: true },
})
